/* Publish by EComposer at 2026-09-30 16:28:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lhglzqolrzg"]=  window.__ectimmers["ecom-lhglzqolrzg"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lhglzqolrzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lhglzqolrzg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fdh05oyq1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fdh05oyq1m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dazsbj8yys5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dazsbj8yys5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3fybl9btqp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3fybl9btqp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oo185dk40t8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oo185dk40t8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rvtsyyt19r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rvtsyyt19r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nnrry6s5g5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nnrry6s5g5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amzen991gia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amzen991gia', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9w5dh03iah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9w5dh03iah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i2wie96t5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i2wie96t5k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-go0ri1uwej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-go0ri1uwej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmd9jyu1vn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmd9jyu1vn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vly3ptv243').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vly3ptv243', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q8kzddv9elc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q8kzddv9elc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yks4bu09fbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yks4bu09fbp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6rt1hhrixom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6rt1hhrixom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2jd0c3wij3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2jd0c3wij3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drssfyedbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drssfyedbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qkyltycr7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qkyltycr7p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bs7ydyjzyhm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bs7ydyjzyhm', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6hjn0cfupbi"]=  window.__ectimmers["ecom-6hjn0cfupbi"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-6hjn0cfupbi"]["7iqfteigo"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-6hjn0cfupbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6hjn0cfupbi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rln5e3pwwq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rln5e3pwwq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7090vnllvvy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7090vnllvvy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ml5btfiytw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ml5btfiytw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6qaei4dgff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6qaei4dgff', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3it3btm87rx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3it3btm87rx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3lquxb5g67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3lquxb5g67', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-75tomsgzjea"]=  window.__ectimmers["ecom-75tomsgzjea"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-75tomsgzjea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75tomsgzjea', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2lsqws18o7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2lsqws18o7k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1n2t3qdaqwg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1n2t3qdaqwg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37xotypa5l5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37xotypa5l5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2th6uzsowu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2th6uzsowu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lm5pqk6ma3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lm5pqk6ma3d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}